import { render, staticRenderFns } from "./WorkerTabsComponent.vue?vue&type=template&id=4d04912d&scoped=true"
import script from "./WorkerTabsComponent.vue?vue&type=script&lang=ts"
export * from "./WorkerTabsComponent.vue?vue&type=script&lang=ts"
import style0 from "./WorkerTabsComponent.vue?vue&type=style&index=0&id=4d04912d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04912d",
  null
  
)

export default component.exports